import { render, staticRenderFns } from "./IconDanger.vue?vue&type=template&id=7c129d11&scoped=true&"
import script from "./IconDanger.vue?vue&type=script&lang=js&"
export * from "./IconDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c129d11",
  null
  
)

export default component.exports